import { initialize, LDClient } from 'launchdarkly-js-client-sdk'
import { useEffect, useState } from 'react'
import { User } from '../Permissions/AuthenticatedUser.context'
import { useAppSelector } from '../root.reducer'

export function useInitializeLD(user: User | null): LDClient | null {
  const launchDarklyProps = useAppSelector(state => state.app.launchDarklyConfig)
  const [featureFlagClient, setFeatureFlagClient] = useState<LDClient | null>(null)
  useEffect(() => {
    if (user && launchDarklyProps?.implementation === 'LAUNCH_DARKLY') {
      const envKey = launchDarklyProps.properties['featureflags.launchdarkly.client-side-id']
      const newLDClient = initialize(envKey, {
        kind: 'user',
        key: user.id.toString(),
        TenantId: user.tenantId,
      })
      newLDClient.on('ready', () => {
        setFeatureFlagClient(newLDClient)
      })
    }
  }, [launchDarklyProps])
  return featureFlagClient
}
